<div class="flex flex-row gap-[16px]" style="margin: 24px">
  <div class="grow flex flex-col gap-[16px]">
    <div class="flex flex-row gap-[16px]">
      <mat-card style="width: calc(50% - 8px)">
        <mat-card-title>Incoming Data</mat-card-title>
        <mat-card-subtitle>Transfer Processes</mat-card-subtitle>
        <div class="flex flex-row justify-center items-center">
          <edc-demo-dashboard-donut-chart
            [data]="
              data.incomingTransfersChart
            "></edc-demo-dashboard-donut-chart>
        </div>
      </mat-card>

      <mat-card style="width: calc(50% - 8px)">
        <mat-card-title>Outgoing Data</mat-card-title>
        <mat-card-subtitle>Transfer Processes</mat-card-subtitle>
        <div class="flex flex-row justify-center items-center">
          <edc-demo-dashboard-donut-chart
            [data]="
              data.outgoingTransfersChart
            "></edc-demo-dashboard-donut-chart>
        </div>
      </mat-card>
    </div>

    <div class="flex flex-row flex-wrap gap-[16px]">
      <edc-demo-dashboard-kpi-card
        class="flex-even-sized"
        label="Your Data Offerings"
        [kpi]="data.numContractDefinitions"></edc-demo-dashboard-kpi-card>

      <edc-demo-dashboard-kpi-card
        class="flex-even-sized"
        label="Your Assets"
        [kpi]="data.numAssets"></edc-demo-dashboard-kpi-card>

      <edc-demo-dashboard-kpi-card
        class="flex-even-sized"
        label="Your Policies"
        [kpi]="data.numPolicies"></edc-demo-dashboard-kpi-card>

      <edc-demo-dashboard-kpi-card
        class="flex-even-sized"
        label="Preconfigured Catalogs"
        [kpi]="data.numCatalogs"></edc-demo-dashboard-kpi-card>

      <edc-demo-dashboard-kpi-card
        class="flex-even-sized"
        label="Contract Agreements"
        [kpi]="data.numContractAgreements"></edc-demo-dashboard-kpi-card>
    </div>
  </div>

  <div class="shrink-0 flex flex-col gap-[16px]" style="width: 420px">
    <mat-card>
	    <mat-card-title>{{dataSpaceNameTitle}}
	    </mat-card-title>

      <mat-card-subtitle>Powered by T-Systems International GmbH</mat-card-subtitle>
      <mat-form-field class="w-full">
        <mat-label>Connector Endpoint</mat-label>
        <input
          #input
          matInput
          ngDefaultControl
          readonly
          [ngModel]="data.connectorUrl"
          (focus)="input.select()" />
        <mat-icon matPrefix>link</mat-icon>
        <button
          mat-icon-button
          matSuffix
          [cdkCopyToClipboard]="data.connectorUrl"
          (click)="input.focus(); input.select()">
          <mat-icon>content_copy</mat-icon>
        </button>
      </mat-form-field>
    </mat-card>
    <mat-card>
      <mat-card-title>Know your Connect</mat-card-title>
      <mat-card-subtitle>Managed dataspace connection service</mat-card-subtitle>
      <div>
        <p>
	        The Connect is Gaia-X, Catena-X and IDSA certified
        </p>
        <p>
	        Interested in learning more about billing, getting started, technical configurations and premium support plans?
        </p>
        <p>
	        Looking for troubleshooting your Connect services?
        </p>
        <div class="flex flex-row !space-x-[10px]">
          <a
            color="secondary"
           [href]="documentURL"
            mat-stroked-button
            target="_blank">
	          Get help!
          </a>
        </div>
      </div>
    </mat-card>
    <mat-card>
      <mat-card-title>Working with Connect</mat-card-title>
      <mat-card-subtitle>Finding your way around Connect</mat-card-subtitle>
      <div>
        <p class="text-justify">
	        Key operations you can perform with Connect
        </p>
        <ul class="list-style-material-icons-check">
          <li>
            View the asset catalog available to you in your Dataspace using the
            <a class="link" [routerLink]="['/catalog-browser']"
              >Catalog Browser</a
            >
          </li>
          <li>
            Negotiate a contract for data sharing in your Dataspace using the
            <a class="link" [routerLink]="['/catalog-browser']"
              >Catalog Browser</a
            >
          </li>
          <li>
            View your existing contracts in the
            <a class="link" [routerLink]="['/contracts']">Contracts</a> page
          </li>
          <li>
            Transfer an asset in your Dataspace using the
            <a class="link" [routerLink]="['/contracts']">Contracts</a> page
          </li>
          <li>
            View which assets have been transferred in your Dataspace in the
            <a class="link" [routerLink]="['/transfer-history']"
              >Transfer History</a
            >
            page
          </li>
          <li>
            View and create assets using the
            <a class="link" [routerLink]="['/my-assets']">Assets</a> page
          </li>
          <li>
            View and create policies and apply these to assets in your Dataspace
            using the
            <a class="link" [routerLink]="['/policies']">Policies</a> page
          </li>
          <li>
            Publish a new asset into your Dataspace using the
            <a class="link" [routerLink]="['/contract-definitions']"
              >Contract Definitions</a
            >
            page
          </li>
        </ul>
      </div>
    </mat-card>
  </div>
</div>
